<script>
  const imgSrc = "/images/logo.webp";
  const imgAlt = "Country Cruel logo";
</script>

<div>
  <link rel="preload" as="image" href={imgSrc} />
  <img src={imgSrc} alt={imgAlt} />
</div>

<style>
  img {
    margin-top: 3rem;
    width: 96vw;
    height: auto;
    max-width: 22rem;
  }
</style>
